(() => {
  // Save the bag note as the shopper types (it rides along to checkout as the order note).
  let timer = null;
  document.addEventListener('input', (e) => {
    const el = e.target.closest('[data-cart-note]');
    if (!el) return;
    clearTimeout(timer);
    timer = setTimeout(() => {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: el.value })
      }).catch(() => {});
    }, 500);
  });

  // A link to a fold-out panel on the product page opens it.
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#pdp-"]');
    if (!a) return;
    const panel = document.getElementById(a.getAttribute('href').slice(1));
    if (panel && panel.tagName === 'DETAILS') panel.open = true;
  });
})();
